import { BASE_ROUTE, RouteParams } from "../../../constants";

export const CHANGE_BASE_ROUTE = `/${BASE_ROUTE}/change`;

export const ChangePages = {
  impacts: {
    root: {
      path: `/impacts/*`
    },
    extendedView: {
      path: `/${RouteParams.impactId}`,
      generateLink: (organisationId: string | number, projectId: number | string, impactId: string | number) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/impacts/${impactId}`
    },
    visualisations: {
      impactAssesment: {
        path: `/`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `${CHANGE_BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/impacts/`
      }
    }
  },
  stakeholders: {
    root: {
      path: `/stakeholders/*`
    },
    extendedView: {
      path: `/${RouteParams.stakeholderId}`,
      generateLink: (organisationId: string | number, projectId: number | string, stakeholderId: string | number) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/stakeholders/${stakeholderId}`
    },
    visualisations: {
      index: {
        path: `/`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `${CHANGE_BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/stakeholders/`
      },
      parameters: {
        path: `/visualisations/${RouteParams.stakeholderType}/${RouteParams.profilingType}`,
        generateLink: (
          organisationId: string | number,
          projectId: number | string,
          stakeholderType: string | number,
          profilingType: string | number
        ) =>
          `${CHANGE_BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/stakeholders/visualisations/${stakeholderType}/${profilingType}`
      }
    }
  },
  benefits: {
    root: {
      path: `/benefits/*`
    },
    extendedView: {
      path: `/${RouteParams.benefitId}`,
      generateLink: (organisationId: string | number, projectId: number | string, benefitId: string | number) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/benefits/${benefitId}`
    }
  },
  audiences: {
    root: {
      path: `/audiences/*`
    },
    readinessTrackingView: {
      path: `/`,
      generateLink: (organisationId: string | number, projectId: number | string) =>
        `${CHANGE_BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/audiences/`
    },
    readinessChartsView: {
      path: `/readiness-charts`,
      generateLink: (organisationId: string | number, projectId: number | string) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/audiences/readiness-charts`
    },
    visualisations: {
      index: {
        path: `/visualisations/`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `${CHANGE_BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/audiences/visualisations`
      },
      params: {
        path: `/visualisations/${RouteParams.section}`,
        generateLink: (organisationId: string | number, projectId: number | string, section: string) =>
          `${CHANGE_BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/audiences/visualisations/${section}`
      }
    },
    extendedView: {
      path: `/${RouteParams.stakeholderId}`,
      generateLink: (organisationId: string | number, projectId: number | string, stakeholderId: string | number) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/audiences/${stakeholderId}`
    }
  },
  impactGroups: {
    root: {
      path: `/impact-groups/*`
    },
    visualisations: {
      path: `/`,
      generateLink: (organisationId: string | number, projectId: number | string) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/impact-groups`
    },
    editView: {
      path: `/${RouteParams.impactGroupId}/edit`,
      generateLink: (organisationId: string | number, projectId: number | string, impactGroupId: number | string) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/impact-groups/${impactGroupId}/edit`
    },
    createView: {
      path: `/create`,
      generateLink: (organisationId: string | number, projectId: number | string) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/impact-groups/create`
    },
    extendedView: {
      path: `/${RouteParams.impactGroupId}`,
      generateLink: (organisationId: string | number, projectId: number | string, impactGroupId: string | number) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/impact-groups/${impactGroupId}`
    }
  },
  actions: {
    root: {
      path: `/actions/*`
    },
    extendedView: {
      path: `/${RouteParams.actionId}`,
      generateLink: (organisationId: string | number, projectId: number | string, actionId: string | number) =>
        `${CHANGE_BASE_ROUTE.replace(
          RouteParams.organisationId,
          organisationId + ""
        )}/projects/${projectId}/actions/${actionId}`
    },
    visualisations: {
      index: {
        path: `/`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `${CHANGE_BASE_ROUTE.replace(RouteParams.organisationId, organisationId + "")}/projects/${projectId}/actions`
      },
      plan: {
        path: `/visualisations`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `${CHANGE_BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/actions/visualisations`
      },
      breakdown: {
        path: `/visualisations/breakdown`,
        generateLink: (organisationId: string | number, projectId: number | string) =>
          `${CHANGE_BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/actions/visualisations/breakdown`
      },
      parameters: {
        path: `/visualisations/${RouteParams.page}`,
        generateLink: (organisationId: string | number, projectId: number | string, page: string) =>
          `${CHANGE_BASE_ROUTE.replace(
            RouteParams.organisationId,
            organisationId + ""
          )}/projects/${projectId}/actions/visualisations/${page}`
      }
    }
  }
};
